import React from 'react';
import { ChecklistCompletionStatus } from 'types/enrollmentService';
import { STEP_COMPLETION_STATUS_TEST_IDS } from '../../constants';
import {
  CompletedCardWrapperStyled,
  CardStatusTextStyled,
  CompletedIconStyled,
  ReadyToBeginStatusTextStyled,
  InProgressStatusTextStyled,
} from './styles';

interface StatusProps {
  status: ChecklistCompletionStatus;
}

const StepCompletionStatus: React.FC<StatusProps> = ({ status }) => {
  switch (status) {
    case ChecklistCompletionStatus.COMPLETED:
      return (
        <CompletedCardWrapperStyled data-test-id={STEP_COMPLETION_STATUS_TEST_IDS.COMPLETED}>
          <CompletedIconStyled width="1.8rem" />
          <CardStatusTextStyled>Completed</CardStatusTextStyled>
        </CompletedCardWrapperStyled>
      );
    case ChecklistCompletionStatus.READY_TO_BEGIN:
      return (
        <ReadyToBeginStatusTextStyled data-test-id={STEP_COMPLETION_STATUS_TEST_IDS.READY_TO_BEGIN}>
          Ready to begin
        </ReadyToBeginStatusTextStyled>
      );
    case ChecklistCompletionStatus.IN_PROGRESS:
      return (
        <InProgressStatusTextStyled data-test-id={STEP_COMPLETION_STATUS_TEST_IDS.IN_PROGRESS}>
          In-Progress
        </InProgressStatusTextStyled>
      );
    case ChecklistCompletionStatus.CANNOT_COMPLETE_YET:
    default:
      return (
        <CardStatusTextStyled data-test-id={STEP_COMPLETION_STATUS_TEST_IDS.CANNOT_COMPLETE_YET}>
          Cannot complete yet
        </CardStatusTextStyled>
      );
  }
};

export default StepCompletionStatus;
